import { logError } from "@/lib/error-handling";
import { apiClient } from "@/services/api";
import type { SavedViewDto } from "@/types";
import type { CreateSavedViewInput, UpdateSavedViewInput } from "@/schemas";
import type { SavedViewGridKey } from "@/entities/SavedView";

export type CreateSavedViewRequest = CreateSavedViewInput;
export type UpdateSavedViewRequest = UpdateSavedViewInput;

export async function fetchSavedViews(
  gridKey: SavedViewGridKey
): Promise<SavedViewDto[]> {
  try {
    return await apiClient<SavedViewDto[]>(
      `/api/saved-views?gridKey=${encodeURIComponent(gridKey)}`,
      { method: "GET", cache: "no-store" }
    );
  } catch (error) {
    logError(error, "fetchSavedViews");
    throw error;
  }
}

export async function createSavedView(
  data: CreateSavedViewRequest
): Promise<SavedViewDto> {
  try {
    return await apiClient<SavedViewDto>("/api/saved-views", {
      method: "POST",
      body: JSON.stringify(data),
    });
  } catch (error) {
    logError(error, "createSavedView");
    throw error;
  }
}

export async function updateSavedView(
  id: string,
  data: UpdateSavedViewRequest
): Promise<SavedViewDto> {
  try {
    return await apiClient<SavedViewDto>(`/api/saved-views/${id}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    });
  } catch (error) {
    logError(error, "updateSavedView");
    throw error;
  }
}

export async function deleteSavedView(id: string): Promise<void> {
  try {
    await apiClient<void>(`/api/saved-views/${id}`, { method: "DELETE" });
  } catch (error) {
    logError(error, "deleteSavedView");
    throw error;
  }
}
